import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
} from "reactstrap"
import classnames from "classnames"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer } from "react-toastify"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"
import { useHistory } from "react-router-dom"

function Agentview() {
  const [Actin, setActin] = useState([])
  const [Actin1, setActin1] = useState([])
  const [Actin2, setActin2] = useState([])

  const [activeTab1, setactiveTab1] = useState("1")

  const toggle1 = tab => {
    if (activeTab1 !== tab) {
      setactiveTab1(tab)
    }
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token
  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)
  const [listPerPage2] = useState(5)
  const [pageNumber2, setPageNumber2] = useState(0)

  const AgentId = sessionStorage.getItem("agentId")

  useEffect(() => {
    GetUsers()
  }, [])

  const GetUsers = () => {
    var token = datas
    axios
      .post(
        URLS.Agentbyid + AgentId,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setActin1(res.data.agent)
        setActin(res.data.productsUploaded)
        setActin2(res.data.subscriptions)
      })
  }

  const pagesVisited = pageNumber * listPerPage
  const lists = Actin.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Actin.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }
  const pagesVisited2 = pageNumber2 * listPerPage2
  const lists2 = Actin2.slice(pagesVisited2, pagesVisited2 + listPerPage2)
  const pageCount2 = Math.ceil(Actin2.length / listPerPage2)
  const changePage2 = ({ selected }) => {
    setPageNumber2(selected)
  }

  const history = useHistory()

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Agent Details" />
          <Row>
            <Col>
              <Button
                onClick={() => history.goBack()}
                className="mb-3  m-1 "
                style={{ float: "right" }}
                color="primary"
              >
                <i className="far fa-arrow-alt-circle-left"></i> Back
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <Card>
                <CardBody>
                  <h5 className="mb-3">Details</h5>
                  <Row>
                    <Col md="4">
                      <b>Promo Code</b>
                    </Col>
                    <Col md="8">
                      <p>:{Actin1.promocode}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <b>Name</b>
                    </Col>
                    <Col md="8">
                      <p>:{Actin1.name}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <b>Phone No</b>
                    </Col>
                    <Col md="8">
                      <p>:{Actin1.phone}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <b>Email</b>
                    </Col>
                    <Col md="8">
                      <p>:{Actin1.email}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <b>Status</b>
                    </Col>
                    <Col md="8">
                      <p>:{Actin1.status}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <b>Address</b>
                    </Col>
                    <Col md="8">
                      <p>: {Actin1.address}</p>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col md="8">
              <Card>
                <CardBody>
                  <Nav pills>
                    <NavItem className="w-25">
                      <NavLink
                        style={{
                          border: "1px #806530 solid",
                          borderRadius: "5px",
                          padding: "8px",
                          margin: "6px",
                        }}
                        className={classnames({
                          active: activeTab1 === "1",
                        })}
                        onClick={() => {
                          toggle1("1")
                        }}
                      >
                        {" "}
                        <span className="bx bx-chevrons-right"></span>
                        Sales ({Actin.length})
                      </NavLink>
                    </NavItem>
                    <NavItem className="w-25">
                      <NavLink
                        style={{
                          border: "1px #806530 solid",
                          borderRadius: "5px",
                          padding: "8px",
                          margin: "6px",
                        }}
                        className={classnames({
                          active: activeTab1 === "2",
                        })}
                        onClick={() => {
                          toggle1("2")
                        }}
                      >
                        {" "}
                        <span className="bx bx-chevrons-right"></span>
                        Subscriptions  ({Actin2.length})
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent
                    activeTab={activeTab1}
                    className="p-4  text-muted"
                  >
                    <TabPane tabId="1">
                      <div className="table-rep-plugin table-responsive">
                        <Table hover className="table table-bordered mb-4">
                          <thead>
                            <tr className="text-center">
                              <th>SlNo</th>
                              <th>User Id</th>
                              <th>User Name</th>
                              <th>Product Name</th>
                              <th>Category</th>
                              <th>Price </th>
                              <th>Address</th>
                            </tr>
                          </thead>
                          <tbody>
                            {lists.map((data, key) => (
                              <tr key={key} className="text-center">
                                <td>{(pageNumber - 1) * 5 + key + 6}</td>
                                <td>{data.userDetails.userUniqueId}</td>
                                <td>{data.userDetails.name}</td>
                                <td>{data.productName}</td>
                                <td>{data.categoryName}</td>
                                <td>₹{data.price} </td>
                                <td>{data.address}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        <div
                          className="d-flex mt-3 mb-1"
                          style={{ float: "right" }}
                        >
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"pagination"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"disabled"}
                            activeClassName={"active"}
                            total={lists.length}
                          />
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tabId="2">
                      <div className="table-rep-plugin table-responsive">
                        <Table hover className="table table-bordered mb-4">
                          <thead>
                            <tr className="text-center">
                              <th>SlNo</th>
                              <th>Purchase Date</th>
                              <th>User Id</th>
                              <th>User Name</th>
                              <th>Plan Name</th>
                              <th>Post Count</th>
                              <th>Entries Count</th>
                              <th>ExpiryDate </th>
                            </tr>
                          </thead>
                          <tbody>
                            {lists2.map((data, key) => (
                              <tr key={key} className="text-center">
                                <td>{(pageNumber2 - 1) * 5 + key + 6}</td>
                                <td>{data?.purchaseDate?.slice(0, 10)}</td>
                                <td>{data?.userDetails.userUniqueId}</td>
                                <td>{data?.userDetails.name}</td>
                                <td>{data?.planDetails?.name}</td>
                                <td>{data?.postCount}</td>
                                <td>{data?.cashBookEntriesCount} </td>
                                <td>{data?.expiryDate?.slice(0, 10)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        <div
                          className="d-flex mt-3 mb-1"
                          style={{ float: "right" }}
                        >
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            pageCount={pageCount2}
                            onPageChange={changePage2}
                            containerClassName={"pagination"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"disabled"}
                            activeClassName={"active"}
                            total={lists2.length}
                          />
                        </div>
                      </div>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Agentview
